import { useMemo } from 'react'
import { useParams } from 'react-router-dom'

import { t } from 'i18next'

import useQueryParams from '~/hooks/useQuery'
import { buildCounterpartQuery } from '~/modules/retailMedia/helpers/isValidCounterpartId'

import { IndustryMovimentationsTable } from '../MovimentationsTable'
import { IndustryPaymentsTable } from '../PaymentsTable'
import Tabs from '../Tabs'
import styles from './walletActivitySection.module.css'

type TabNameInterface = 'movimentations' | 'transactions'

export const IndustryTransactionTable = () => {
  const { id, section } = useParams() as {
    id: string
    section: TabNameInterface
  }
  const counterpartQuery = buildCounterpartQuery(useQueryParams().get('rmid'))

  const tabs: TabsProps['tabs'] = useMemo(
    () => [
      {
        to: `/retail-media/wallet/${id}/movimentations${counterpartQuery}`,
        label: t('rm:Transactions')
      },
      {
        to: `/retail-media/wallet/${id}/transactions${counterpartQuery}`,
        label: t('rm:Payments')
      }
    ],
    [counterpartQuery, id]
  )

  return (
    <section
      className={styles.section}
      aria-labelledby="wallet-activity-heading"
      data-testid="wallet-activity-section"
      data-wallet-activity-section
    >
      <div className={`${styles.sectionHead} ${styles.sectionHeadWithTabs}`}>
        <h2 id="wallet-activity-heading" className={styles.heading}>
          {t('rm:Movimentations')}
        </h2>
        <div className={styles.tabs}>
          <Tabs tabs={tabs} />
        </div>
      </div>

      <div className={styles.sectionBody}>
        {section === 'movimentations' && <IndustryMovimentationsTable />}
        {section === 'transactions' && <IndustryPaymentsTable />}
      </div>
    </section>
  )
}
